
import BootstrapModal from '../../components/BootstrapModal';
import {Formik, Form, Field} from 'formik'
import TextField from "../../components/TextField";
import * as Yup from 'yup'
import PMSCheckBox from "../../components/PMSCheckBox";
import {ProgressSpinner} from "primereact/progressspinner";

const userRoleForm = ({modal,userRoleID,roleName,active,isLoading,onSubmit,onHide}) => {
    const validation = Yup.object({
        roleName:  Yup.string().required('Please Enter Role Name').max(200,"Max length Exceed..!"),
        //roleTitle: Yup.string().required('Role Title is Required'),
    })    
    console.log(userRoleID);
    // const customHandleSubmit = e =>{
    //     e.preventDefault();

    //    const formJson = {
    //        "userRoleID":e.target.userRoleID.value,
    //        "roleName":e.target.roleName.value,
    //        "active":e.target.active.checked,
    //        "addedBy":e.target.addedBy.value
    //    }
    //    console.log(formJson);
    //    onSubmit(formJson)
    // }

  return (
    <BootstrapModal headerText="Add Role Name" size={30} visible={modal} onHide={onHide}>
                {/* <form method='POST' className='mt-3' onSubmit={customHandleSubmit}>
                    <input type="hidden" name="userRoleID" id='userRoleID' defaultValue={userRoleID}/>
                    <div className="form-outline mb-3">
                        <input type="roleName" name='roleName'
                            placeholder='Enter Role Name..'
                            id="roleName"
                            defaultValue={roleName}
                            autoComplete="off" className="form-control" />
                        <span className='text-danger'/>
                    </div>                    
                    <div className="form-group mb-3">
                        <div className="form-check">
                            <input                           
                            className="form-check-input" type="checkbox" name="active" id="active"  checked={active}/>
                            <label className="form-check-label" htmlFor="active">Active</label>
                        </div>
                    </div>

                    <input type="hidden" name='addedBy' id='addedBy' value="forhad"/>

                    <button type='submit' className='btn btn-primary'>Save</button>
                </form> */
                <Formik
                validationSchema={validation}
                initialValues={{userRoleID: userRoleID,roleName: roleName, active: active}}
                onSubmit={onSubmit}>
                {formik =>
                    (<>
                        <Form>
                            <Field type="hidden" name="userRoleID"/>
                            <TextField label={'Role Name'} type="text" name="roleName" />                           
                            <PMSCheckBox name={'active'} id={'active'}/>
                            {isLoading ? <ProgressSpinner style={ {height:30,width:30} }/> : <button type="submit" disabled={isLoading} className="btn btn-primary">{userRoleID === 0 ? 'Save' : 'Update'} </button>}
                            
                        </Form>
                    </>)}

            </Formik>
                
                }
            </BootstrapModal>
  )
}

export default userRoleForm